import {ARTICLE_PROMOTION_ARCHIVE_TYPE} from 'app/utils/Consts';

export const getArticleLinkType = (type: string): string => {
    if (type === ARTICLE_PROMOTION_ARCHIVE_TYPE) {
        return 'promotions';
    }

    return type;
};
